import { differenceInCalendarDays, format, isToday, isYesterday, parseISO, } from "date-fns";
import { enUS, es } from "date-fns/locale";
const RECENT_DAY_LIMIT = 6;
function parseMessageDate(value) {
    const parsed = parseISO(value);
    return Number.isNaN(parsed.getTime()) ? new Date(value) : parsed;
}
function localeFor(language) {
    return language.startsWith("en") ? enUS : es;
}
export function formatMessageDateLabel(date, language = "es") {
    const normalizedLanguage = language.startsWith("en") ? "en" : "es";
    if (isToday(date))
        return normalizedLanguage === "en" ? "Today" : "Hoy";
    if (isYesterday(date)) {
        return normalizedLanguage === "en" ? "Yesterday" : "Ayer";
    }
    const daysAgo = differenceInCalendarDays(new Date(), date);
    if (daysAgo > 1 && daysAgo <= RECENT_DAY_LIMIT) {
        return normalizedLanguage === "en"
            ? `${daysAgo} days ago`
            : `hace ${daysAgo} días`;
    }
    return format(date, "P", { locale: localeFor(normalizedLanguage) });
}
export function formatExactMessageDate(date, language = "es") {
    return format(date, "PPPP", { locale: localeFor(language) });
}
export function groupMessagesByDate(messages, language = "es") {
    const groups = new Map();
    for (const message of messages) {
        const date = parseMessageDate(message.created_at);
        const key = format(date, "yyyy-MM-dd");
        const existing = groups.get(key);
        if (existing) {
            existing.messages.push(message);
            continue;
        }
        groups.set(key, {
            key,
            date,
            label: formatMessageDateLabel(date, language),
            exactLabel: formatExactMessageDate(date, language),
            messages: [message],
        });
    }
    return Array.from(groups.values());
}
